<template>
  <div id="myDnloadHome">
    <div>
      <div class="allDl m_t_20 d_flex">
        <dl class="allDl_width30 allDl_span60" style="width: 80%">
          <dd>
            <span>文件名:</span>
            <div>
              <input v-model="filename" type="text" class="allInput" placeholder="请输入"/>
            </div>
          </dd>
          <dt style="width: auto;">
            <button @click="getAllList" class="suerButton"><i class="icon iconfont iconsousuo" style="font-size: 14px"></i><span class="m_l_5">搜索</span></button>
          </dt>
        </dl>
      </div>
      <div style="max-height: calc(100vh - 270px);overflow: auto">
        <table class="allTable" cellspacing="0">
          <thead>
          <tr>
            <th width="20"></th>
            <th style="text-align: left">文件名称</th>
<!--            <th>最近更新时间</th>-->
<!--            <th width="60">操作</th>-->
          </tr>
          </thead>
          <tbody :key="index" v-for="(item, index) in myList">
          <tr>
            <td width="20" colspan="4" class="f_w"  style="text-align: left">
              <i @click="onClickF(item)" class="icon iconfont iconicon_7 dis_line" :style="{'transform': item.isClickF ? '' : 'rotate(-90deg)'}" style="transition: all .5s"></i>
              <span class="m_l_10">{{ item.category }}</span>
            </td>
          </tr>
          <tr :key="indexCl" v-for="(itemCl, indexCl) in item.list" v-if="item.isClickF" @click="toUrl(itemCl)" class="c_p">
            <td width="20"></td>
            <td style="text-align: left">{{ itemCl.wideTableName }}</td>
<!--            <td>{{$commonJs.returnDate(item.lastModifyTime, 'YYMMDD')}}</td>-->
<!--            <td class="colorYellowF36A20" width="60">-->
<!--              <span @click="toUrl(itemCl)" class="c_p">查看</span>-->
<!--            </td>-->
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'myDnloadHome',
  data () {
    return {
      filename: '',
      myList: []
    }
  },
  created () {
    this.$commonJs.addLog('查看', '数据下载', '数据下载', '')
    this.getAllList()
  },
  methods: {
    getAllList () {
      this.$axiox.get('/api/Download/GetWideTableList?filename=' + this.filename).then(msg => {
        this.myList = msg.data || []
        for (let i = 0; i < this.myList.length; i++) {
          this.$set(this.myList[i], 'isClickF', true)
        }
      })
    },
    onClickF (item) {
      item.isClickF = !item.isClickF
    },
    toUrl (item) {
      this.$commonJs.addLog('点击', '数据下载', '数据下载', item.wideTableName)
      if (item.wideTableType === 'Default') {
        this.$router.push({
          name: 'myDnloadHomeDetail',
          query: {
            formChildTableId: item.childTableId,
            formName: item.wideTableName
          }
        })
      } else {
        this.$router.push({
          name: 'myDnloadHomeTwoDetail',
          query: {
            formChildTableId: item.id
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/myDnload/myDnloadHome.vue